import {
  type FeedbackResponse,
  type FeedbackSubmission,
  SAUCE_TYPES,
  type SauceType,
  type SessionUpsert,
} from "./types";

export async function submitFeedback(payload: FeedbackSubmission): Promise<FeedbackResponse> {
  const res = await fetch("/api/feedback", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (res.status === 409) {
    return { ok: true, status: "duplicate" };
  }

  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`feedback submit failed: ${res.status} ${body}`.trim());
  }

  return { ok: true, status: "created" };
}

export async function submitSession(payload: SessionUpsert): Promise<void> {
  const res = await fetch("/api/session", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`session submit failed: ${res.status} ${body}`.trim());
  }
}

export function readEventSlugFromUrl(fallback: string): string {
  const params = new URLSearchParams(window.location.search);
  const e = params.get("e")?.trim();
  return e && e.length > 0 ? e : fallback;
}

export function readSauceFromUrl(): SauceType | null {
  const params = new URLSearchParams(window.location.search);
  const s = params.get("sauce")?.trim().toLowerCase();
  if (!s) return null;
  return SAUCE_TYPES.includes(s as SauceType) ? (s as SauceType) : null;
}
